module.exports = __webpack_public_path__ + "img/tokyo_hilton.ab37c255.jpg";